module.exports = __webpack_public_path__ + "static/img/pic_xgt.59ba37d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic_xgt.jpg
// module id = 84PU
// module chunks = 1